import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../../components/Text'

const Box = styled.div`
  text-align: center;
  color: var(--green);
  margin: 1.5rem 0;
`

const Icon = styled.div`
  margin-right: 0.5rem;
`

export default class ErrorMessage extends Component {
  render() {
    return (
      <Box>
        <Icon className="fas fa-check-circle" />
        <Text str="prose.changesSaved" />
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Card/SavedMessage.js